import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class NuevaTransactionService {

     constructor(private http: HttpClient) {
    
    }

    registrar(transaction) {
      // console.log("entramos en registrar")

      return this.http.post<any>('https://vertigofin.herokuapp.com/', { transaction })
        .pipe(map(confirmacion => {
       
            // console.log("entramos en respuesta de registrar transaction")
            // console.log(confirmacion)
            return confirmacion;
        }));
    }


}